import { atom } from 'jotai';

export const htmlEditorActionDisabledAtom = atom<boolean>(true);
